import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';

export default function InventoryTableHeaderWithTooltip(props) {
  const { text, tooltip, sortElement } = props;

  const overlay = <Tooltip>{tooltip}</Tooltip>;

  return (
    <OverlayTrigger overlay={overlay}>
      <p>
        {text}
        {sortElement}
      </p>
    </OverlayTrigger>
  );
}

InventoryTableHeaderWithTooltip.prototype = {
  text: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  sortElement: PropTypes.func,
};
